import Changeset from 'ember-changeset';
import announcementValidations from 'garaje/validations/announcement';
import lookupValidator from 'ember-changeset-validations';

export default function (announcement) {
  const validator = lookupValidator(announcementValidations);

  return new Changeset(announcement, validator, announcementValidations);
}
